export function getCookie(name: string): string {
    if (typeof document === "undefined") {
        return "";
    }

    const prefix = `${encodeURIComponent(name)}=`;
    const entry = document.cookie.split("; ").find((cookie) => cookie.startsWith(prefix));
    return entry ? decodeURIComponent(entry.slice(prefix.length)) : "";
}

export function setCookie(name: string, value: string, maxAge = 7 * 24 * 60 * 60) {
    if (typeof document === "undefined") {
        return;
    }

    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; samesite=lax`;
}

export function clearCookie(name: string) {
    if (typeof document === "undefined") {
        return;
    }

    document.cookie = `${encodeURIComponent(name)}=; path=/; max-age=0; samesite=lax`;
}
